import { useCallback, useMemo } from 'react';
import { isEmpty } from 'lodash';
import { UseFormReturn } from 'react-hook-form';
import { useMessages } from 'modules/intl';
import { NOTE_FIELDS } from '../common/noteSchema';

export const errorMessagesKeys = [
  'note.error.time',
  'note.error.maxCommentLength',
  'note.error.fieldRequired',
  'note.error.startTimeRequired',
  'note.error.endTimeRequired',
  'note.error.endTimeShouldBeGreaterThanStartTime',
  'note.error.startAndEndTimeShouldNotBeEqual',
  'note.error.durationRequired'
];

export const useFormErrorMessage = ({
  errors
}: UseFormReturn['formState']): ((
  type: NOTE_FIELDS
) => string | null | undefined) => {
  const errorMessages = useMessages(errorMessagesKeys);
  const memoizedErrors = useMemo(() => (isEmpty(errors) ? undefined : errors), [
    errors
  ]);

  return useCallback(
    (type: NOTE_FIELDS) =>
      memoizedErrors
        ? errorMessages[(memoizedErrors[type] as any)?.message ?? '']
        : '',
    [errorMessages, memoizedErrors]
  );
};
